module.exports = __webpack_public_path__ + "static/media/icon-star-yellow.21b81779.svg";